import { useQuery } from '@tanstack/react-query';
import { BidvVirtualAccountService, GenQrBidvEntity } from 'services/openapi';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type GetQrBidvVAWithAmountQueryDTO = {
  vaPrefix: string;
  endCode: string;
  amount: string | number | null;
  enabled?: boolean;
  requestId?: number;
};

export const useGetQrBidvVAWithAmountQuery = (
  variables: GetQrBidvVAWithAmountQueryDTO,
) => {
  const {
    enabled = true,
    amount,
    endCode,
    vaPrefix,
    requestId = 0,
  } = variables;
  const normalizedAmount = amount == null ? '' : amount.toString();
  const queryKey = [
    BidvVirtualAccountServiceQueryKeys.GET_QR_WITH_AMOUNT,
    vaPrefix,
    endCode,
    normalizedAmount,
    requestId,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GenQrBidvEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerGetQrWithAmount(
        vaPrefix,
        endCode,
        normalizedAmount,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled:
      enabled &&
      !!vaPrefix &&
      !!endCode &&
      normalizedAmount !== '' &&
      normalizedAmount !== '0',
  });

  return {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};
